export default "__VITE_ASSET__Bgewk9Wo__"